/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PaymentMethods/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import BankAccountPayment from './BankAccountPayment/index'
import CashPayment from './CashPayment/index'
import CheckPayment from './CheckPayment/index'
import CreditCardManualPayment from './CreditCardManualPayment/index'
import CreditCardPayment from './CreditCardPayment/index'
import No from './No/index'
import OtherPayment from './OtherPayment/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PaymentMethods({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/PaymentMethods"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentsPostPaymentPaymentMethodDataPaymentsPaymentTypeValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payment_method.data.payments_payment_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentsPostPaymentPaymentMethodDataPaymentsPaymentTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CashPayment'}>
<CashPayment
  viewPath={`${viewPath}/CashPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckPayment'}>
<CheckPayment
  viewPath={`${viewPath}/CheckPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreditCardPayment'}>
<CreditCardPayment
  viewPath={`${viewPath}/CreditCardPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CreditCardManualPayment'}>
<CreditCardManualPayment
  viewPath={`${viewPath}/CreditCardManualPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OtherPayment'}>
<OtherPayment
  viewPath={`${viewPath}/OtherPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BankAccountPayment'}>
<BankAccountPayment
  viewPath={`${viewPath}/BankAccountPayment`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}